import { Button } from "@mui/joy";
import { sendMessage } from "utils/webview";
import useIsInappWebview from "../../hooks/useIsInappWebview";

export default function ButtonLink({
  disabled,
  text,
  url,
}: {
  disabled: boolean;
  text: string;
  url: string;
}) {
  const isInappWebview = useIsInappWebview();
  return (
    <Button
      onClick={() => {
        if (isInappWebview) {
          sendMessage(
            JSON.stringify({
              event: "open_link",
              params: {
                url: url,
              },
            })
          );
        } else {
          window.open(url, "_blank");
        }
      }}
      disabled={disabled}
    >
      {text}
    </Button>
  );
}